// @todo -> Listen for response from ajax poller + sync control state 
NtechApp.ContactManager = function() {
    var me = this;

    this._ajax = null;
    this._click = null;

    this._construct = function() {
        me._ajax = new NtechApp.Ajax();
        me._click = new NtechApp.TouchClickEvent();

        me._bindEvents();
    }

    this._bindEvents = function() {
        me._click.listen($("body"), "[data-triggerAddToContacts]", function(event) {
            var $item = $(event.target).closest("[data-triggerAddToContacts]");

            if($item.hasClass("lockedButton"))
                return;

            $item.addClass("lockedButton");
            me._addToContacts($item, $item.attr("data-triggerAddToContacts"));
        });

        me._click.listen($("body"), "[data-triggerRmFromContacts]", function(event) {
            var $item = $(event.target).closest("[data-triggerRmFromContacts");

            var processRm = function() {
                if($item.hasClass("lockedButton"))
                    return;

                $item.addClass("lockedButton");
                me._rmFromContacts($item, $item.attr("data-triggerRmFromContacts"));
            };

            if(NtechApp.dom.hasAttribute($item.get(0), "data-rmConfirmation")) {
                NtechApp.confirmForm.load(function() { 
                    NtechApp.confirmForm.unload();
                    processRm.call(me); 
                });
            }
            else 
                processRm.call(me);
        });
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.ContactManager.EVENT_CONTACT_REMOVE = "NtechApp.ContactManager.EventContactRemove";

NtechApp.proto(NtechApp.ContactManager, {
    _getAddToContactsRoute: function() {
        if(NtechApp.clientSettings.isPersonal)
            return 'personal_add_to_contacts';
        else if(NtechApp.clientSettings.isBusiness)
            return 'business_add_to_contacts';
    },

    _getRmFromContactsRoute: function() {
        if(NtechApp.clientSettings.isPersonal)
            return 'personal_rm_from_contacts';
        else if(NtechApp.clientSettings.isBusiness)
            return 'business_rm_from_contacts';
    },

    _addToContacts: function($item, opponentId) {
        var me = this;
        var params = {
            opponentId: opponentId
        };

        $item.find("[data-ajaxHide]").css("display", "none");
        $item.find("[data-ajaxLoaderText]").text("");

        me._ajax.enableTextLoading($item.find("[data-ajaxLoaderText]"));

        me._ajax.post({
            url: Routing.generate(me._getAddToContactsRoute()),
            data: params,
            onSuccess: function(data) {
                me._syncContactControlState($item, data);
                NtechApp.info.on("Contact request successfully sent to " + $item.attr("data-opponentFullname") + ".", 2500);
            },
            onComplete: function() {
                $item.removeClass("lockedButton");
                me._ajax.disableTextLoading($item.find("[data-ajaxLoaderText]"));
            }
        });
    },

    _rmFromContacts: function($item, opponentId) {
        var me = this;
        var params = {
            opponentId: opponentId
        };

        $item.find("[data-ajaxHide]").css("display", "none");
        $item.find("[data-ajaxLoaderText]").text("");

        me._ajax.enableTextLoading($item.find("[data-ajaxLoaderText]"));

        me._ajax.post({
            url: Routing.generate(me._getRmFromContactsRoute()),
            data: params,
            onSuccess: function(data) {
                me._syncContactControlState($item, data);
                $(me).trigger(NtechApp.ContactManager.EVENT_CONTACT_REMOVE);

                NtechApp.info.on($item.attr("data-opponentFullname") + " successfully removed from contacts.", 2500);
            },
            onComplete: function() {
                $item.removeClass("lockedButton");
                me._ajax.disableTextLoading($item.find("[data-ajaxLoaderText]"));
            }
        });
    },

    _syncContactControlState: function($item, data) {
        var $text = $item.find("[data-text]");
        var $icon = $item.find(".controlIcon");
        var $subicon = $item.find(".controlSubicon");

        $text.css("display", "inline-block");

        $item.removeAttr("data-triggerRmFromContacts").removeAttr("data-triggerAddToContacts");
        $item.removeAttr("data-rmConfirmation");
        
        $item.removeClass("userMinusIconWrapper").removeClass("userIconWrapper");
        $item.removeClass("greenUserMinusIconWrapper").removeClass("greenUserIconWrapper");
        $item.removeClass("userPlusIconWrapper").removeClass("greenUserPlusIconWrapper");

        $icon.removeClass("userIcon").removeClass("userMinusIcon").removeClass("userPlusIcon");
        $icon.css("display", "inline-block");

        if(data.status == "accepted") {
            $text.text("Remove contact");
            $item.addClass("userMinusIconWrapper greenUserMinusIconWrapper");
            $icon.addClass("userMinusIcon");

            $item.attr("data-triggerRmFromContacts", $item.attr("data-opponentAccountId"));
            $item.attr("data-rmConfirmation", "e");
        }
        else if(data.status == "declined") {
            $text.text("Request declined");
            $item.addClass("userIconWrapper greenUserIconWrapper");
            $icon.addClass("userIcon");
        }
        else if(data.status == "sent") {
            if(data.isContactRequestSentByViewer) {
                $text.text("Cancel request");
                $item.addClass("userMinusIconWrapper greenUserMinusIconWrapper");
                $icon.addClass("userMinusIcon");

                $item.attr("data-triggerRmFromContacts", $item.attr("data-opponentAccountId"));
            }
            else {
                $text.text("Request received");
                $item.addClass("userIconWrapper greenUserIconWrapper");
                $icon.addClass("userIcon");
            }
        }
        else if(data.status == "canceled" || data.status == "removed") {
            $text.text("Add to contacts");
            $item.addClass("userPlusIconWrapper greenUserPlusIconWrapper");
            $icon.addClass("userPlusIcon");

            $item.attr("data-triggerAddToContacts", $item.attr("data-opponentAccountId"));
        }
    }
});